import React from 'react';

const ServicesSection = () => {
  const services = [
    {
      icon: 'fas fa-certificate',
      title: 'BDA',
      description: 'Bangalore Development Authority approved sites and plots. Complete assistance with BDA approvals and documentation.'
    },
    {
      icon: 'fas fa-stamp',
      title: 'BRMDA',
      description: 'Bangalore Rural Metropolitan Development Authority approved properties with full legal support.'
    },
    {
      icon: 'fas fa-exchange-alt',
      title: 'DC Conversion',
      description: 'Development Control conversion services for all types of land with expert guidance and complete documentation.'
    },
    {
      icon: 'fas fa-file-alt',
      title: 'Revenue Sites',
      description: 'Revenue site properties with clear titles and complete legal documentation for hassle-free transactions.'
    },
    {
      icon: 'fas fa-home',
      title: 'Houses',
      description: 'Residential houses available for purchase and rent. Independent houses with modern amenities.'
    },
    {
      icon: 'fas fa-map',
      title: 'Land',
      description: 'Residential and commercial land parcels with clear titles. Prime locations for your dream projects.'
    },
    {
      icon: 'fas fa-warehouse',
      title: 'Shed',
      description: 'Industrial and commercial sheds for purchase and rent. Suitable for warehouses and manufacturing units.'
    },
    {
      icon: 'fas fa-seedling',
      title: 'Agriculture Land',
      description: 'Fertile agricultural land for farming and investment. Properties with water facilities and road access.'
    },
    {
      icon: 'fas fa-drafting-compass',
      title: 'Architecture Plans',
      description: 'Professional architectural design and planning services for houses and sheds at discounted prices.'
    },
    {
      icon: 'fas fa-hammer',
      title: 'Construction Services',
      description: 'Complete construction services for houses and sheds with quality materials at discounted rates.'
    }
  ];

  return (
    <section id="services" className="services" aria-labelledby="services-heading">
      <div className="container">
        <header 
          className="section-header"
        >
          <div className="section-badge">OUR EXPERTISE</div>
          <h2 id="services-heading">Property Types & Services Across India</h2>
          <p>All types of BDA, BRMDA, DC conversion, Revenue sites, Houses, Land, Shed, Agriculture Land for purchase and rent across Karnataka, Goa, Andhra Pradesh, Tamil Nadu, Pune, and Mumbai. Architecture plans and construction services at discounted prices.</p>
          
          <div className="services-highlights" role="list" aria-label="Service highlights">
            <div 
              className="highlight-item"
              role="listitem"
            >
              <div className="highlight-icon" aria-hidden="true">
                <i className="fas fa-home"></i>
              </div>
              <div className="highlight-content">
                <span className="highlight-number" aria-label="250 plus properties sold">250+</span>
                <span className="highlight-label">Properties Sold</span>
              </div>
            </div>
            <div 
              className="highlight-item"
              role="listitem"
            >
              <div className="highlight-icon" aria-hidden="true">
                <i className="fas fa-users"></i>
              </div>
              <div className="highlight-content">
                <span className="highlight-number" aria-label="98 percent client satisfaction">98%</span>
                <span className="highlight-label">Client Satisfaction</span>
              </div>
            </div>
            <div 
              className="highlight-item"
              role="listitem"
            >
              <div className="highlight-icon" aria-hidden="true">
                <i className="fas fa-calendar"></i>
              </div>
              <div className="highlight-content">
                <span className="highlight-number" aria-label="15 plus years experience">15+</span>
                <span className="highlight-label">Years Experience</span>
              </div>
            </div>
            <div 
              className="highlight-item"
              role="listitem"
            >
              <div className="highlight-icon" aria-hidden="true">
                <i className="fas fa-percentage"></i>
              </div>
              <div className="highlight-content">
                <span className="highlight-number" aria-label="25 percent discounted rates">25%</span>
                <span className="highlight-label">Discounted Rates</span>
              </div>
            </div>
          </div>
        </header>

        <div className="services-grid" role="list" aria-label="Available services">
          {services.map((service, index) => (
            <article
              key={index}
              className="service-card"
              role="listitem"
            >
              <div className="service-icon" aria-hidden="true">
                <i className={service.icon}></i>
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <button 
                className="service-contact-btn"
                onClick={() => {
                  const message = `Hi! I'm interested in your ${service.title} service. Please provide more details about:

${service.description}

I would like to know more about pricing, process, and timeline.`;
                  
                  const whatsappURL = `https://wa.me/919187458799?text=${encodeURIComponent(message)}`;
                  window.open(whatsappURL, '_blank');
                }}
                aria-label={`Get quote for ${service.title} service via WhatsApp`}
              >
                <i className="fab fa-whatsapp" aria-hidden="true"></i>
                <span>Get Quote</span>
              </button>
            </article>
          ))}
        </div>

        {/* Special Offers Section */}
        <div 
          className="services-offers"
        >
          <div className="offer-card">
            <div className="offer-badge">
              <i className="fas fa-percentage"></i>
              <span>Special Offer</span>
            </div>
            <h3>Architecture & Construction Package</h3>
            <p>Get professional architectural plans and construction services at discounted prices. Complete package includes:</p>
            <ul className="offer-features">
              <li><i className="fas fa-check"></i> Architectural Design & Planning</li>
              <li><i className="fas fa-check"></i> Structural Engineering</li>
              <li><i className="fas fa-check"></i> BDA/BRMDA Approvals</li>
              <li><i className="fas fa-check"></i> Construction Management</li>
              <li><i className="fas fa-check"></i> Quality Materials & Craftsmanship</li>
            </ul>
            <div className="offer-cta">
              <button 
                className="offer-btn"
                onClick={() => {
                  const message = `Hi! I'm interested in your Architecture & Construction Package with discounted pricing.

I would like to know more about:
- Architectural design and planning services
- Construction services for houses/sheds
- BDA and BRMDA approval assistance
- Package pricing and discounts available
- Timeline for completion

Please provide detailed information and quotation.`;
                  
                  const whatsappURL = `https://wa.me/919187458799?text=${encodeURIComponent(message)}`;
                  window.open(whatsappURL, '_blank');
                }}
              >
                <i className="fab fa-whatsapp"></i>
                <span>Get Discounted Quote</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;